import { useQueryClient } from '@tanstack/react-query';
import { api } from '../../../shared/api.js';
import { useApiMutation } from '../../../shared/useApi.js';

export function useSettle({ onSuccess } = {}) {
  const qc = useQueryClient();

  return useApiMutation({
    mutationFn: async (body) => {
      const { data } = await api.post('/pos/checkout/settle-session', body);
      return data;
    },
    onSuccess: (data, vars) => {
      invalidateAfterSettle(qc, vars?.sessionId);
      if (onSuccess) onSuccess(data, vars);
    }
  });
}

/** تسوية عدة أطفال على نفس الكارت (أو طفل واحد) دفعةً واحدة. */
export function useSettleGroup({ onSuccess } = {}) {
  const qc = useQueryClient();

  return useApiMutation({
    mutationFn: async (body) => {
      const { data } = await api.post('/pos/checkout/settle-group', body);
      return data;
    },
    onSuccess: (data, vars) => {
      invalidateAfterSettle(qc, (vars?.sessionIds || [])[0]);
      if (onSuccess) onSuccess(data, vars);
    }
  });
}

function invalidateAfterSettle(qc, sessionId) {
  qc.invalidateQueries({ queryKey: ['sessions', 'active'] });
  qc.invalidateQueries({ queryKey: ['checkout'] });
  if (sessionId) {
    qc.invalidateQueries({ queryKey: ['checkout', 'session', sessionId] });
    qc.invalidateQueries({ queryKey: ['checkout', 'group', sessionId] });
  }
  // مفاتيح لوحة المعلومات هي ['dash', ...] وليست ['dashboard'].
  qc.invalidateQueries({ queryKey: ['dash'] });
  qc.invalidateQueries({ queryKey: ['cards'] });
  qc.invalidateQueries({ queryKey: ['cashboxes'] });
}

export async function printCheckoutReceipt(sessionId) {
  if (!sessionId) return null;
  try {
    const { data } = await api.post(`/print/checkout/${sessionId}`);
    return data;
  } catch (err) {
    // print failures are non-fatal — surfaced via toast at call site
    return Promise.reject(err);
  }
}
